import { useAsync } from '@tiger/hooks';
import { Form, Input } from 'antd';
import React from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import Card from 'components/Card';
import ErrorBox from 'components/ErrorBox';
import FormItem from 'components/FormItem';
import Loading from 'components/Loading';
import Toast from 'components/Toast';
import security from 'stores/security';
import API from 'utils/API';
import http from 'utils/http';

const Success: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const verifyToken = (location.state as any)?.verify_token || '';
    const [state, getInfo] = useAsync(() => {
        const params: any = {
            account_id: security.currentAccountId,
            verify_token: verifyToken
        };

        return http
            .post<{ ib_password: string; ib_username: string }>(API.CUSTOMER.ibPasswrod(), params)
            .then(res => res.data)
            .catch(err => {
                if (err.error_code === 11084) {
                    // 操作时长过长
                    navigate('../1');
                    Toast.show(err);

                    return { ib_username: '', ib_password: '' };
                }

                throw err;
            });
    });

    if (!verifyToken) {
        return <Navigate to="../1" replace />;
    }

    return (
        <Card form>
            {state.error ? (
                <ErrorBox error={state.error} onClick={getInfo} />
            ) : state.loading ? (
                <Loading tip={__('获取中')} />
            ) : (
                <Form layout="vertical">
                    <h3 className="sub-title desc">{__('Your login credential for portal as follows')}</h3>
                    <Card className="ib-result">
                        <FormItem label={__('User Name')}>
                            <Input value={state.data?.ib_username} readOnly />
                        </FormItem>
                        <FormItem label={__('Initial Password')}>
                            <Input value={state.data?.ib_password} readOnly />
                        </FormItem>

                        <a
                            target="_blank"
                            href="https://www.clientam.com/sso/Login?partnerID=MARSCO"
                            className="text-center d-block mt-5">
                            {__('Go to Client Portal')}
                        </a>
                    </Card>
                    <div className="ib-tips">
                        {__(
                            `Note: You will be forced to change the password, when you log in to the client portal by using your initial password. Please keep your new password safe.The initial password will immediately become invalid once you change the password.`
                        )}
                    </div>
                </Form>
            )}
        </Card>
    );
};

export default Success;
